import {getColorStyle, getFontSize, getSettingsColor} from '@wix/wix-events-commons-statics'
import {AppProps} from '../components/app/interfaces'

export const POPUP_LAYOUT_BREAKPOINT = 500
export const VERTICAL_POPUP_FULL_HEIGHT_BREAKPOINT = 700
export const SIDE_BY_SIDE_POPUP_FULL_HEIGHT_BREAKPOINT = 450

export const getBorderStyle = (
  context: Pick<AppProps, 'host'>,
  direction: 'top' | 'right' | 'bottom' | 'left' | '' = '',
) =>
  getColorStyle(
    context.host.style,
    `border-${direction ? `${direction}-` : ''}color`,
    'color-2',
    'calendarCellBorderColor',
  )

export const getActionBackground = (context: Pick<AppProps, 'host'>) =>
  getColorStyle(context.host.style, 'background-color', 'color-8', 'calendarMainActiveColor', 0.2)

export const getOtherMonthBackground = (context: Pick<AppProps, 'host'>) => {
  return getSettingsColor(context.host.style, 'calendarPastDaysBackground')
    ? getColorStyle(context.host.style, 'background-color', 'color-2', 'calendarPastDaysBackground')
    : getColorStyle(context.host.style, 'background-color', 'color-2', undefined, 0.1)
}

export const getShareFontSize = (context: Pick<AppProps, 'host'>): string => getFontSize(context.host.style, 'Body-M')
